import { useEffect } from 'react';
import { MINDY_APP_URL, USERS_LANDING_URL } from '../config';

const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refreshToken';

function buildLoginUrl(): string {
    const redirectBack = MINDY_APP_URL || globalThis.location.href;
    return `${USERS_LANDING_URL}/login?logout=true&redirect=${redirectBack}`;
}

export function useAuthGuard(): void {
    useEffect(() => {
        const handleStorageEvent = (event: StorageEvent): void => {
            if (event.key === 'logout' && event.newValue) {
                localStorage.removeItem(TOKEN_KEY);
                localStorage.removeItem(REFRESH_TOKEN_KEY);
                globalThis.location.assign(buildLoginUrl());
            }
        };

        window.addEventListener('storage', handleStorageEvent);
        return () => window.removeEventListener('storage', handleStorageEvent);
    }, []);
}
